const MOVEMENT_KEYS=new Set(['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Shift']);

export function createKeyboardInputState(){
 const keys=new Set();
 return {
  keydown(key,{blocked=false}={}){
   if(blocked){return {handled:key.startsWith('Arrow'),moved:false,escape:false};}
   if(key==='Escape'){keys.clear();return {handled:true,moved:false,escape:true};}
   if(MOVEMENT_KEYS.has(key)){keys.add(key);return {handled:true,moved:key.startsWith('Arrow'),escape:false};}
   return {handled:false,moved:false,escape:false};
  },
  keyup(key){const handled=keys.delete(key);return {handled};},
  clear(){keys.clear();},
  direction({blocked=false}={}){
   if(blocked)return {x:0,z:0};
   return {x:Number(keys.has('ArrowRight'))-Number(keys.has('ArrowLeft')),z:Number(keys.has('ArrowDown'))-Number(keys.has('ArrowUp'))};
  },
  get gentle(){return keys.has('Shift');}
 };
}

export function clampDragTarget(x,z,limit=3.42){
 const safeLimit=Number.isFinite(limit)&&limit>0?limit:3.42;
 const clamp=v=>Number.isFinite(v)?Math.max(-safeLimit,Math.min(safeLimit,v)):0;
 return {x:clamp(x),z:clamp(z)};
}
